import * as React from 'react';

import Alert from 'src/components/common/Alert';

import './HeaderBanner.scss';
import { goToDashboard } from 'src/utils/navigation';

class HeaderBanner extends React.Component<IHeaderBannerProps, any> {
  constructor(props: any) {
    super(props);
  }

  private shouldGoToDashboard = () => {
    if (this.props.accountHasChanged) {
      this.props.changeActiveAccountFlag(false);
      goToDashboard();
    }
  };

  public componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.accountHasChanged !== this.props.accountHasChanged) {
      this.shouldGoToDashboard();
    }
  };

  public render() {
    return this.props.specialUser ? (
      <Alert
        type="info"
        message={`You are now emulating client #${this.props.userData.accountId}`}
        icon={'rpds-error'}
        styleClass="rp-header-banner"
        handleCloseAlert={() => {
          return;
        }}
      >
        <div
          onClick={e =>
            this.props.changeActiveAccount(
              this.props.userData.specialUser,
              this.props.userData.specialUser
            )
          }
        >
          Back to Dashboard
        </div>
      </Alert>
    ) : null;
  }
}

export default HeaderBanner;

interface IHeaderBannerProps {
  specialUser: string;
  userData: any;
  accountHasChanged: boolean;
  changeActiveAccountFlag(flag: boolean): void;
  changeActiveAccount(newAccountId: string, clientIdentity: string): void;
}
